import { marked } from "marked";
import DOMPurify from "dompurify";

marked.setOptions({
  breaks: true,
});

export function renderMarkdownSafe(md: string): string {
  const raw = marked.parse(md ?? "");
  return DOMPurify.sanitize(raw);
}
